import { jsx as a, jsxs as b } from "../../../_virtual/jsx-runtime.mjs";
import r from "react";
import j from "./ItemLabel.mjs";
import O from "./ItemInput.mjs";
import C from "../../../depend/classnames/index.mjs";
import { reoFormItem as P, itemStatusHelp as k, itemStatusWarning as z, itemStatusError as D, fieldRequired as G, labelLeft as S, labelInner as J, labelRight as K, reoFormItemContent as Q, itemFocused as U, itemFilled as X } from "../css/ReoFormItem.mjs";
import F from "../hooks/useDebounce.mjs";
import Y from "./StatusProvider.mjs";
import { getStatus as Z } from "./common.mjs";
import $ from "../../../depend/rc-util/lib/Dom/isVisible.mjs";
import { useTheme as p } from "../../../hook/useTheme.mjs";
import { EThemeTemplate as ee } from "../../../common/type.mjs";
import "../context/FormItemInputContext.mjs";
import { FormContext as te } from "../context/ReoFormCompContext.mjs";
function Ce(e) {
  const {
    help: i,
    errors: s,
    warnings: c,
    meta: n,
    validateStatus: N,
    required: u,
    rules: o,
    isFocused: y,
    isFilled: E,
    theme: v,
    fixMarginBottom: I
  } = e, { formItemClassName: R } = r.useContext(te), l = r.useRef(null), w = p({ theme: v, template: ee.FORM }), x = F(e.errors), A = F(e.warnings), f = i != null, d = !!(f || s.length || c.length), M = !!l.current && $(l.current), [m, g] = r.useState(null), B = r.useMemo(() => !!u || (o == null ? void 0 : o.some((t) => t.required)), [u, o]), V = C(
    w,
    P,
    {
      [k]: f,
      [z]: !!c.length,
      [D]: !!s.length
    },
    B ? G : null,
    R,
    "reo-basic-form-item",
    e.className
  ), q = r.useMemo(() => {
    switch (e.labelAlign) {
      case "left":
        return S;
      case "right":
        return K;
      case "inner":
        return J;
      default:
        return S;
    }
  }, [e.labelAlign]), T = C(
    Q,
    q,
    {
      [U]: y,
      [X]: E
    },
    "reo-basic-form-item-content"
  );
  r.useLayoutEffect(() => {
    if (d && l.current) {
      const t = getComputedStyle(l.current);
      g(parseInt(t.marginBottom, 10));
    }
  }, [d, M]);
  const h = ((t = !1) => {
    const W = t ? x : n.errors, _ = t ? A : n.warnings;
    return Z(W, _, n, "", N);
  })(), H = (t) => {
    t || g(null);
  }, L = r.useMemo(() => typeof e.colon == "boolean" ? e.colon : !e.labelAlign || e.labelAlign === "left", [e.colon, e.labelAlign]);
  return /* @__PURE__ */ a(
    "div",
    {
      className: V,
      ref: l,
      children: /* @__PURE__ */ b(
        Y,
        {
          meta: n,
          errors: n.errors,
          warnings: n.warnings,
          validateStatus: h,
          children: [
            /* @__PURE__ */ b("div", { className: T, children: [
              /* @__PURE__ */ a(
                j,
                {
                  ...e,
                  className: e.labelClassName,
                  style: e.labelStyle,
                  colon: L,
                  htmlFor: e.name
                }
              ),
              /* @__PURE__ */ a(
                O,
                {
                  ...e,
                  className: e.inputClassName,
                  style: e.inputStyle,
                  marginBottom: m,
                  status: h,
                  onErrorVisibleChanged: H,
                  children: e.children
                }
              )
            ] }),
            !!m && !I && // 辅助占位元素，用于抵消ErrorList的部分高度
            /* @__PURE__ */ a(
              "div",
              {
                style: {
                  marginBottom: -m
                }
              }
            )
          ]
        }
      )
    }
  );
}
export {
  Ce as default
};
//# sourceMappingURL=ItemHolder.mjs.map
